// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__32ogH","detailsBorder":"styles_detailsBorder__2eVhq"};